export const siteMapUrls = Object.freeze({
  url: {
    TERMS_OF_USE_URL: 'https://www.lslog.com/terms',
    PRIVACY_POLICY_URL: 'https://www.lslog.com/privacy-policy',
    TRADEMARKS_URL: 'https://www.lslog.com/trademarks',
  },
})
